"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.number.constructor");
require("core-js/modules/es6.function.name");
var _SetupModulePopup = _interopRequireDefault(require("./SetupModulePopup.vue"));
var _activeBinding = require("@/api/activeBinding");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'ModulePopup',
  components: {
    SetupModulePopup: _SetupModulePopup.default
  },
  data: function data() {
    return {
      loading: false,
      showPopup: false,
      locationName: '',
      // tabs名
      platformCodeData: [],
      // 金刚区类目接口
      tableData: [],
      queryData: {
        id: null,
        bannerEnable: '',
        //	banner是否启用
        activityName: '',
        // 活动名称
        region: null,
        // 区域（首页...）
        category: '',
        //	所属分类(金刚区)
        locationCode: '',
        //	位置编码（热门，购物...(1-5)）
        page: {
          page: 1,
          size: 10
        }
      },
      pagination: {
        // currentPage: 1, // 默认第几页
        total: 0 // 条数
      },
      isSubmoduleNot: false,
      // 是否存在子模块
      titleName: null
    };
  },
  methods: {
    open: function open(data) {
      document.querySelector('body').style.overflow = 'hidden';
      /*
      接收data对象：
      name：名称
      region: 1, // 区域（首页...）
      id：id(金刚位id)
      category:''//所属分类(金刚区)
      */
      this.queryData.id = data.id;
      this.queryData.region = data.region;
      this.queryData.category = data.category;
      this.titleName = data.name;
      if (Number(data.category) === 4) {
        this.isSubmoduleNot = true;
        this.getLocationsApi();
      } else {
        this.isSubmoduleNot = false;
        this.getModelDetail();
      }
      this.showPopup = true;
    },
    onClone: function onClone() {
      this.showPopup = false;
      document.querySelector('body').style.overflow = '';
      this.onInit();
    },
    onInit: function onInit() {
      this.isSubmoduleNot = false;
      this.titleName = '';
      this.queryData = {
        id: null,
        bannerEnable: '',
        //	banner是否启用
        activityName: '',
        // 活动名称
        region: null,
        // 区域（首页...）
        category: '',
        //	所属分类(金刚区)
        locationCode: '',
        //	位置编码（热门，购物...(1-5)）
        page: {
          page: 1,
          size: 10
        }
      };
      this.pagination = {
        currentPage: 1,
        // 默认第几页
        total: 0 // 条数
      };
    },
    handleClick: function handleClick(tab, event) {
      this.locationName = tab.label;
      this.queryData.page.page = 1;
      this.queryData.page.size = 10;
      this.getModelDetail();
    },
    // 查询
    onInquire: function onInquire() {
      this.queryData.page.page = 1;
      this.queryData.page.size = 10;
      this.getModelDetail();
    },
    // 重置
    onInitialize: function onInitialize() {
      this.queryData.page.page = 1;
      this.queryData.page.size = 10;
      this.queryData.bannerEnable = '';
      this.queryData.activityName = '';
      this.getModelDetail();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.queryData.page.size = val;
      this.getModelDetail();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.queryData.page.page = val;
      this.getModelDetail();
    },
    // 新增
    onAdd: function onAdd() {
      this.$refs.setupModulePopup.open({
        id: this.queryData.id,
        region: this.queryData.region,
        category: this.queryData.category,
        locationCode: this.queryData.locationCode,
        locationName: this.locationName,
        type: 'add',
        titleName: this.titleName
      });
    },
    // 编辑
    onEditor: function onEditor(data) {
      this.$refs.setupModulePopup.open({
        id: data.id,
        type: 'editor',
        titleName: this.titleName
      });
    },
    // 删除
    onDelete: function onDelete(data) {
      var _this = this;
      this.$confirm('是否确认删除此活动?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this.unbindingBannerApi(data.id, data.modelId);
      });
    },
    // 防止穿透
    handleSmallDivClick: function handleSmallDivClick() {},
    onRefreshList: function onRefreshList() {
      this.queryData.page.page = 1;
      this.queryData.page.size = 10;
      this.getModelDetail();
      this.$parent.findAll();
    },
    // 查询
    getModelDetail: function () {
      var _getModelDetail2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var params, res, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              this.loading = true;
              params = (0, _objectSpread2.default)({}, this.queryData);
              _context.n = 1;
              return (0, _activeBinding.getModelDetail)(params);
            case 1:
              res = _context.v;
              this.loading = false;
              if (res.code === 0) {
                this.tableData = res.data.activityList.data;
                this.pagination.total = res.data.activityList.total;
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              this.loading = false;
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function getModelDetail() {
        return _getModelDetail2.apply(this, arguments);
      }
      return getModelDetail;
    }(),
    // 获取该类型下所有的位置信息
    getLocationsApi: function () {
      var _getLocationsApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var params, res, _t2;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              params = {
                id: this.queryData.id
              };
              _context2.n = 1;
              return (0, _activeBinding.getLocationsApi)(params);
            case 1:
              res = _context2.v;
              if (res.code === 0) {
                this.platformCodeData = res.data;
                if (res.data) {
                  this.queryData.locationCode = res.data[0].locationCode;
                  this.locationName = res.data[0].locationName;
                }
                this.getModelDetail();
              }
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              console.log(_t2);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function getLocationsApi() {
        return _getLocationsApi2.apply(this, arguments);
      }
      return getLocationsApi;
    }(),
    // 删除
    unbindingBannerApi: function () {
      var _unbindingBannerApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3(id, modelId) {
        var params, res, _t3;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              params = {
                id: id,
                modelId: modelId
              };
              _context3.n = 1;
              return (0, _activeBinding.unbindingBannerApi)(params);
            case 1:
              res = _context3.v;
              if (res.code === 0) {
                this.$notify.success({
                  title: '温馨提示',
                  message: '删除成功'
                });
                this.getModelDetail();
                this.$parent.findAll();
              }
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t3 = _context3.v;
              console.log(_t3);
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function unbindingBannerApi(_x, _x2) {
        return _unbindingBannerApi2.apply(this, arguments);
      }
      return unbindingBannerApi;
    }()
  }
};